__turbopack_context__.v({
  "content": "PeopleCard-module-scss-module__dB-4Jq__content",
  "email-html": "PeopleCard-module-scss-module__dB-4Jq__email-html",
  "excerpt": "PeopleCard-module-scss-module__dB-4Jq__excerpt",
  "image": "PeopleCard-module-scss-module__dB-4Jq__image",
  "image-wrapper": "PeopleCard-module-scss-module__dB-4Jq__image-wrapper",
  "main": "PeopleCard-module-scss-module__dB-4Jq__main",
  "name": "PeopleCard-module-scss-module__dB-4Jq__name",
  "office": "PeopleCard-module-scss-module__dB-4Jq__office",
  "phone": "PeopleCard-module-scss-module__dB-4Jq__phone",
  "title": "PeopleCard-module-scss-module__dB-4Jq__title",
  "wrapper": "PeopleCard-module-scss-module__dB-4Jq__wrapper",
});
